import apiURLBuilder from '../core/apiURLBuilder';
import { goToErrorsView } from './errorViewNavigation';
import Api from '../services/api';
import actionTypes from 'constants/actionTypes';

const postML2 = (cookie, request_id, accessToken) => dispatch => {
    const saveRequestData = {
        header: {
            Authorization: `Bearer ${accessToken}`,
        },
        query: {
            cookie,
            requestId: request_id,
        },
    };
    const getPostML2URL = apiURLBuilder.getURL('postML2');

    return Api.post(getPostML2URL, saveRequestData).then(response => {
        if (response.body.status !== 'Error') {
            const data = response.body || [];

            dispatch({
                type: actionTypes.LOAD_ML2,
                data,
            });
        } else {
            dispatch(goToErrorsView({ errorCode: response.body.status, errorMessage: getPostML2URL }));
        }
    });
};

const postJaffar = (accessToken, cb) => dispatch => {
    const saveRequestData = {
        header: {
            Authorization: `Bearer ${accessToken}`,
        },
        query: {},
    };

    return Api.post(apiURLBuilder.getURL('postJaffar'), saveRequestData)
        .then(response => {
            const data = response.body || [];
            dispatch({
                type: actionTypes.LOAD_JAFFAR,
                data,
            });
            cb(true, data);
        })
        .catch(() => cb(false));
};

const setScoringML2 = data => dispatch => {
    dispatch({
        type: actionTypes.LOAD_ML2,
        data,
    });
};

const setScoringJaffar = data => dispatch => {
    dispatch({
        type: actionTypes.LOAD_JAFFAR,
        data,
    });
};

const getLimitJaffar = (accessToken, cb) => dispatch => {
    const saveRequestData = {
        header: {
            Authorization: `Bearer ${accessToken}`,
        },
        query: {},
    };

    return Api.post(apiURLBuilder.getURL('getLimitJaffar'), saveRequestData)
        .then(response => {
            const data = response.body || [];
            dispatch({
                type: actionTypes.LOAD_JAFFAR,
                data,
            });
            cb(true);
        })
        .catch(() => cb(false));
};

export default {
    postML2,
    postJaffar,
    setScoringML2,
    setScoringJaffar,
    getLimitJaffar,
};
